import { toBaseStudyEntity } from './study-entity.js';
import { checkDefined } from 'faro-common-model';
import { toScheduledDayType } from './scheduled-day-type.js';
import { StudyEntityType } from './study-entity-type.js';
export const scheduledDayNameMaxLength = 60;
const ruleTypesRequiringEpochDay = new Set(['fixed', 'non-fixed-day']);
/**
 * @return the built ScheduledDay entity
 */
export function toScheduledDay(scheduledDay) {
    checkDefined(scheduledDay.scheduleOfActivitiesId, 'ScheduledDay', 'scheduleOfActivitiesId');
    checkDefined(scheduledDay.epochId, 'ScheduledDay', 'epochId');
    checkDefined(scheduledDay.type, 'ScheduledDay', 'type');
    checkDefined(scheduledDay.ruleIds, 'ScheduledDay', 'ruleIds');
    checkDefined(scheduledDay.activityIds, 'ScheduledDay', 'activityIds');
    if (ruleTypesRequiringEpochDay.has(scheduledDay.type)) {
        checkDefined(scheduledDay.epochDay, 'ScheduledDay', 'epochDay');
    }
    if (scheduledDay.type === 'non-fixed-day') {
        checkDefined(scheduledDay.endEpochDay, 'ScheduledDay', 'endEpochDay');
    }
    return {
        ...toBaseStudyEntity(scheduledDay, StudyEntityType.ScheduledDay),
        type: toScheduledDayType(scheduledDay.type),
        scheduleOfActivitiesId: scheduledDay.scheduleOfActivitiesId,
        activityIds: [...scheduledDay.activityIds],
        epochId: scheduledDay.epochId,
        epochDay: ruleTypesRequiringEpochDay.has(scheduledDay.type) ? scheduledDay.epochDay : undefined,
        endEpochDay: scheduledDay.type === 'non-fixed-day' ? scheduledDay.endEpochDay : undefined,
        ruleIds: [...scheduledDay.ruleIds],
        visitWindow: scheduledDay.visitWindow,
        name: scheduledDay.name,
        cycle: scheduledDay.cycle,
        derivedCardinality: scheduledDay.derivedCardinality != null ? structuredClone(scheduledDay.derivedCardinality) : {},
    };
}
//# sourceMappingURL=scheduled-day.js.map